import { render, staticRenderFns } from "./DadosCadastraisDash.vue?vue&type=template&id=0dcb13af&"
import script from "./DadosCadastraisDash.vue?vue&type=script&lang=js&"
export * from "./DadosCadastraisDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports